import React from 'react';
import Linkify from "react-linkify";
import FileIcon from "./icons/FileIcon";
import Const from "../core/Const";
import {connect} from "react-redux";
import {dialogsActions} from "../redux/actions";
import store from "../redux/store";

const Message = ({item, attachments, user}) => {

    let uid = item.user ? item.user.id : user.id;

    let contentClassList = [
        'sc-message--content',
        (uid === user.id ? 'sent' : 'received')
    ];

    const renderAttachment = item => {
        item.url = Const.URL + "/" + item.url;

        return (
            <a key={Math.random()} className="sc-message--file" href={item.url} download={item.filename}>
                <FileIcon/>
                <p>{item.filename}</p>
            </a>
        );
    };

    if (item.text.length === 0) {
        return "";
    }

    let avatar = '/assets/chat-icon.png';

    if (uid !== user.id) {
        store.dispatch(dialogsActions.setOperatorParams(item.user.last_name + " " + item.user.first_name, item.user.avatar));

        if (item.user.avatar) {
            avatar = Const.URL + "/" + item.user.avatar;
        }
    }

    return (
        <div className="sc-message">
            <div className={contentClassList.join(' ')}>
                <div className="sc-message--text">{<Linkify properties={{target: '_blank'}}>{item.text}</Linkify>}</div>
                {attachments && attachments.map(item => renderAttachment(item))}
            </div>
        </div>
    );
};


export default connect(() => (
    {...dialogsActions}
))(Message);
